import axios from 'axios';

export const { get, all, post, put, spread } = axios;
